import SubGenreAddModal, { SubGenreAddModalReturnData } from 'features/MenuBook/components/SubGenreAddModal';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
function SubGenreAddModalDemo() {
  const [show, setShow] = useState(false);

  function handleClose() {
    setShow(false);
  }

  function handleShowModal() {
    setShow(true);
  }

  function onReflect(returnData: SubGenreAddModalReturnData) {
    console.log('returnData', returnData);
  }

  return (
    <>
      <Button onClick={handleShowModal}>SubGenreAddModalDemo </Button>
      <SubGenreAddModal
        isShowModal={show}
        genreId={1}
        genreName="123123123"
        exceptSubgenreIds={[1]}
        onReflect={onReflect}
        onClose={handleClose}
      ></SubGenreAddModal>
    </>
  );
}
export default SubGenreAddModalDemo;
